import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IAddInventoryRequest,
  IAddInventoryResponse,
  IInventoryRequest,
  IInventoryResponse,
  ISearchInventoryResponse,
} from "./inventory.interface";
import {
  addInventoryService,
  getInventoryService,
  searchInventoryService,
} from "./inventory.service";
import { IPagination } from "@/commons/commons.interfaces";

export const addInventory = createAsyncThunk<
  IAddInventoryResponse,
  IAddInventoryRequest,
  { rejectValue: any }
>("inventory/addInventory", async (payload, { rejectWithValue }) => {
  try {
    const data = await addInventoryService(payload);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const getInventory = createAsyncThunk<
  {
    pagination: IPagination;
    products: IInventoryResponse[];
  },
  IInventoryRequest,
  { rejectValue: any }
>("inventory/getInventory", async (payload, { rejectWithValue }) => {
  try {
    const data = await getInventoryService(
      payload.page,
      payload.limit,
      payload.sort,
      payload.order,
      payload.search
    );
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});

export const searchInventory = createAsyncThunk<
  ISearchInventoryResponse[],
  string,
  { rejectValue: any }
>("inventory/searchInventory", async (search, { rejectWithValue }) => {
  try {
    const data = await searchInventoryService(search);
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response.data?.message);
  }
});
